import { DateTime } from "luxon";
import ReactDOM from "react-dom/client";
import Timer from "../../components/Timer/Timer";

[...document.querySelectorAll("[data-sq-component-type=timer]")].forEach((element: HTMLElement) => {
  const dateTimeFormat = "yyyy-MM-dd H:m:s";
  const { timer } = element.dataset;

  let date = DateTime.fromFormat(timer, `${dateTimeFormat} ZZ`);

  // Use UTC+2 (Switzerland's Summer time) as default if no timezone is set.
  if (!date.isValid) {
    date = DateTime.fromFormat(timer, dateTimeFormat, { zone: "UTC+2" });
  }

  ReactDOM.createRoot(element).render(<Timer date={date} />);
});
